import { render } from "./WaySection.vue?vue&type=template&id=6593fe7e&scoped=true"
import script from "./WaySection.vue?vue&type=script&lang=js"
export * from "./WaySection.vue?vue&type=script&lang=js"

import "./WaySection.vue?vue&type=style&index=0&id=6593fe7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6593fe7e"]])

export default __exports__